export const categories = [
  { slug: "lianai", name: "恋爱", icon: "ri-heart-line", description: "甜蜜浪漫的爱情故事，感受心动瞬间" },
  { slug: "rexue", name: "热血", icon: "ri-fire-line", description: "激情澎湃的战斗冒险，燃起你的斗志" },
  { slug: "qihuan", name: "奇幻", icon: "ri-magic-line", description: "探索异世界的神秘旅程，开启奇幻冒险" },
  { slug: "gaoxiao", name: "搞笑", icon: "ri-emotion-laugh-line", description: "轻松幽默的日常趣事，笑到停不下来" },
  { slug: "kongbu", name: "恐怖", icon: "ri-ghost-line", description: "惊悚刺激的悬疑故事，挑战你的胆量" },
  { slug: "xiaoyuan", name: "校园", icon: "ri-building-line", description: "青春校园的点点滴滴，回忆美好时光" },
  { slug: "maoxian", name: "冒险", icon: "ri-compass-3-line", description: "勇敢踏上未知旅途，探索世界奥秘" },
  { slug: "xuanyi", name: "悬疑", icon: "ri-search-eye-line", description: "层层揭开谜底真相，锻炼你的推理能力" },
];

export const allComics = [
  {
    id: 1,
    title: "星辰之恋",
    author: "林小雨",
    cover: "https://readdy.ai/api/search-image?query=Beautiful%20anime%20manga%20style%20illustration%20of%20a%20couple%20under%20starry%20night%20sky%2C%20soft%20pink%20and%20purple%20tones%2C%20romantic%20atmosphere%2C%20shojo%20manga%20art%20style%2C%20clean%20background%20with%20stars%2C%20elegant%20character%20design%2C%20warm%20lighting%2C%20Japanese%20anime%20aesthetic&width=400&height=560&seq=manga-cover-01&orientation=portrait",
    category: "lianai",
    description: "高中生林星辰意外遇见了来自遥远星系的少女，一段跨越星际的浪漫爱情故事就此展开。两人在不同的星球文化中互相理解、成长，最终克服重重困难走到一起。故事融合了科幻与爱情元素，画风唯美细腻，深受读者喜爱。",
    status: "连载中",
    rating: 9.7,
    views: 1258000,
    updateDate: "2026-08-03",
    tags: ["恋爱", "科幻", "校园", "治愈"],
    chapters: [
      { num: 1, title: "第一话 星之邂逅", date: "2025-03-15" },
      { num: 2, title: "第二话 异星来客", date: "2025-03-22" },
      { num: 3, title: "第三话 心动的信号", date: "2025-03-29" },
      { num: 4, title: "第四话 星空下的约定", date: "2025-04-05" },
      { num: 5, title: "第五话 跨越光年的思念", date: "2025-04-12" },
      { num: 6, title: "第六话 两颗心的距离", date: "2025-04-19" },
      { num: 7, title: "第七话 银河彼岸", date: "2025-04-26" },
      { num: 8, title: "第八话 星际危机", date: "2025-05-03" },
      { num: 9, title: "第九话 守护之人", date: "2025-05-10" },
      { num: 10, title: "第十话 永恒之约", date: "2025-05-17" },
      { num: 11, title: "第十一话 新的冒险", date: "2025-05-24" },
      { num: 12, title: "第十二话 归途", date: "2025-06-01" },
    ],
  },
  {
    id: 2,
    title: "烈焰战神",
    author: "陈浩",
    cover: "https://readdy.ai/api/search-image?query=Epic%20anime%20manga%20illustration%20of%20a%20warrior%20with%20flaming%20sword%2C%20intense%20battle%20scene%2C%20red%20and%20orange%20fire%20effects%2C%20dynamic%20action%20pose%2C%20shonen%20manga%20art%20style%2C%20dark%20background%20with%20embers%2C%20powerful%20hero%20character%2C%20clean%20composition&width=400&height=560&seq=manga-cover-02&orientation=portrait",
    category: "rexue",
    description: "在一个被火焰之力主宰的世界，少年凌天觉醒了传说中的烈焰血脉。为了守护家园，他踏上了成为最强烈焰战神的征程。热血沸腾的战斗场面，扣人心弦的剧情发展，让你体验最纯粹的热血冒险！",
    status: "连载中",
    rating: 9.5,
    views: 2380000,
    updateDate: "2026-08-02",
    tags: ["热血", "战斗", "奇幻", "成长"],
    chapters: [
      { num: 1, title: "第一话 觉醒", date: "2024-08-10" },
      { num: 2, title: "第二话 试炼之路", date: "2024-08-17" },
      { num: 3, title: "第三话 烈焰初燃", date: "2024-08-24" },
      { num: 4, title: "第四话 宿命对决", date: "2024-08-31" },
      { num: 5, title: "第五话 突破极限", date: "2024-09-07" },
      { num: 6, title: "第六话 王者归来", date: "2024-09-14" },
      { num: 7, title: "第七话 火焰之心", date: "2024-09-21" },
      { num: 8, title: "第八话 终极之战", date: "2024-09-28" },
      { num: 9, title: "第九话 新的传说", date: "2024-10-05" },
      { num: 10, title: "第十话 烈焰永恒", date: "2024-10-12" },
    ],
  },
  {
    id: 3,
    title: "幻梦之境",
    author: "苏瑾",
    cover: "https://readdy.ai/api/search-image?query=Dreamy%20anime%20manga%20illustration%20of%20a%20girl%20in%20a%20magical%20dreamscape%2C%20floating%20crystals%20and%20butterflies%2C%20soft%20pastel%20colors%20with%20lavender%20and%20mint%20tones%2C%20fantasy%20world%20aesthetic%2C%20shojo%20manga%20style%2C%20ethereal%20atmosphere%2C%20detailed%20background%20with%20castles&width=400&height=560&seq=manga-cover-03&orientation=portrait",
    category: "qihuan",
    description: "少女程梦在入睡后总会进入一个奇妙的梦境世界。在这里，她拥有操控梦境的能力，但也发现了一个关于现实世界的巨大秘密。梦境与现实交织，奇幻与悬疑并存，带你进入一个前所未有的幻想世界。",
    status: "已完结",
    rating: 9.6,
    views: 1890000,
    updateDate: "2026-07-15",
    tags: ["奇幻", "梦境", "冒险", "治愈"],
    chapters: [
      { num: 1, title: "第一话 入梦", date: "2025-01-05" },
      { num: 2, title: "第二话 镜中世界", date: "2025-01-12" },
      { num: 3, title: "第三话 梦之守护者", date: "2025-01-19" },
      { num: 4, title: "第四话 破碎的记忆", date: "2025-01-26" },
      { num: 5, title: "第五话 真相之门", date: "2025-02-02" },
      { num: 6, title: "第六话 最终之梦", date: "2025-02-09" },
    ],
  },
  {
    id: 4,
    title: "校园爆笑日记",
    author: "王大锤",
    cover: "https://readdy.ai/api/search-image?query=Funny%20anime%20manga%20illustration%20of%20hilarious%20school%20life%20comedy%2C%20exaggerated%20facial%20expressions%2C%20chibi%20style%20characters%2C%20bright%20vibrant%20colors%2C%20comedy%20manga%20art%2C%20classroom%20setting%2C%20multiple%20characters%20in%20funny%20situations%2C%20clean%20white%20background&width=400&height=560&seq=manga-cover-04&orientation=portrait",
    category: "gaoxiao",
    description: "普通高中生张平凡的校园生活一点也不平凡！奇葩同学、搞笑老师、乌龙事件，每一天都充满了让人捧腹大笑的故事。轻松幽默的四格漫画风格，是解压放松的最佳选择！",
    status: "连载中",
    rating: 9.2,
    views: 3120000,
    updateDate: "2026-08-04",
    tags: ["搞笑", "校园", "日常", "四格"],
    chapters: [
      { num: 1, title: "第一话 开学第一天", date: "2025-06-01" },
      { num: 2, title: "第二话 食堂大作战", date: "2025-06-08" },
      { num: 3, title: "第三话 考试风云", date: "2025-06-15" },
      { num: 4, title: "第四话 运动会趣事", date: "2025-06-22" },
      { num: 5, title: "第五话 文化祭", date: "2025-06-29" },
      { num: 6, title: "第六话 暑假计划", date: "2025-07-06" },
      { num: 7, title: "第七话 社团大战", date: "2025-07-13" },
      { num: 8, title: "第八话 校园怪谈", date: "2025-07-20" },
    ],
  },
  {
    id: 5,
    title: "暗夜之瞳",
    author: "墨染",
    cover: "https://readdy.ai/api/search-image?query=Dark%20atmospheric%20anime%20manga%20horror%20illustration%2C%20shadowy%20figure%20with%20glowing%20eyes%2C%20gothic%20aesthetic%2C%20monochrome%20with%20red%20accents%2C%20creepy%20mansion%20background%2C%20mysterious%20atmosphere%2C%20seinen%20manga%20style%2C%20detailed%20lineart%2C%20clean%20dark%20composition&width=400&height=560&seq=manga-cover-05&orientation=portrait",
    category: "kongbu",
    description: "小镇上接连发生离奇失踪事件，高中生林夜发现自己能够看到常人看不到的'暗影'。随着调查深入，一个隐藏在小镇地下的恐怖真相逐渐浮出水面。紧张刺激的悬疑剧情，让你欲罢不能！",
    status: "连载中",
    rating: 9.4,
    views: 1560000,
    updateDate: "2026-08-01",
    tags: ["恐怖", "悬疑", "超自然", "推理"],
    chapters: [
      { num: 1, title: "第一话 失踪", date: "2025-09-10" },
      { num: 2, title: "第二话 暗影显现", date: "2025-09-17" },
      { num: 3, title: "第三话 地下迷宫", date: "2025-09-24" },
      { num: 4, title: "第四话 远古封印", date: "2025-10-01" },
      { num: 5, title: "第五话 牺牲", date: "2025-10-08" },
      { num: 6, title: "第六话 光与暗", date: "2025-10-15" },
      { num: 7, title: "第七话 真相浮现", date: "2025-10-22" },
    ],
  },
  {
    id: 6,
    title: "樱花树下",
    author: "赵樱花",
    cover: "https://readdy.ai/api/search-image?query=Beautiful%20anime%20manga%20illustration%20of%20students%20under%20blooming%20cherry%20blossom%20trees%2C%20spring%20atmosphere%2C%20soft%20pink%20petals%20falling%2C%20school%20uniforms%2C%20warm%20sunlight%2C%20youthful%20romance%20vibe%2C%20shojo%20manga%20style%2C%20clean%20bright%20composition%2C%20emotional%20scene&width=400&height=560&seq=manga-cover-06&orientation=portrait",
    category: "xiaoyuan",
    description: "转学生周小樱在樱花盛开的季节来到新学校，在樱花树下邂逅了神秘少年。一段关于青春、友情和梦想的校园故事就此展开。唯美的画风，温馨的剧情，带你重温最美好的校园时光。",
    status: "已完结",
    rating: 9.3,
    views: 2010000,
    updateDate: "2026-06-20",
    tags: ["校园", "恋爱", "青春", "治愈"],
    chapters: [
      { num: 1, title: "第一话 樱花盛开", date: "2025-04-01" },
      { num: 2, title: "第二话 邂逅", date: "2025-04-08" },
      { num: 3, title: "第三话 社团活动", date: "2025-04-15" },
      { num: 4, title: "第四话 夏日祭典", date: "2025-04-22" },
      { num: 5, title: "第五话 告白", date: "2025-04-29" },
      { num: 6, title: "第六话 樱花之约", date: "2025-05-06" },
    ],
  },
  {
    id: 7,
    title: "海域探险队",
    author: "刘洋",
    cover: "https://readdy.ai/api/search-image?query=Adventure%20anime%20manga%20illustration%20of%20explorers%20on%20a%20ship%20sailing%20on%20vast%20ocean%2C%20sea%20monsters%20in%20distance%2C%20dynamic%20composition%2C%20blue%20and%20teal%20color%20scheme%2C%20shonen%20manga%20style%2C%20treasure%20map%20aesthetic%2C%20exciting%20atmosphere%2C%20detailed%20character%20designs&width=400&height=560&seq=manga-cover-07&orientation=portrait",
    category: "maoxian",
    description: "年轻的水手阿海在古老的航海图中发现了传说中失落之岛的线索。他召集了一群志同道合的伙伴，驾驶帆船驶向未知的海域。巨浪、海怪、神秘遗迹，一场波澜壮阔的海洋冒险就此起航！",
    status: "连载中",
    rating: 9.1,
    views: 980000,
    updateDate: "2026-08-03",
    tags: ["冒险", "海洋", "寻宝", "友情"],
    chapters: [
      { num: 1, title: "第一话 古老海图", date: "2026-01-10" },
      { num: 2, title: "第二话 集结伙伴", date: "2026-01-17" },
      { num: 3, title: "第三话 启航", date: "2026-01-24" },
      { num: 4, title: "第四话 暴风雨", date: "2026-01-31" },
      { num: 5, title: "第五话 神秘岛屿", date: "2026-02-07" },
      { num: 6, title: "第六话 海底遗迹", date: "2026-02-14" },
      { num: 7, title: "第七话 守护者", date: "2026-02-21" },
      { num: 8, title: "第八话 失落宝藏", date: "2026-02-28" },
    ],
  },
  {
    id: 8,
    title: "推理之绊",
    author: "张明智",
    cover: "https://readdy.ai/api/search-image?query=Mystery%20anime%20manga%20illustration%20of%20a%20detective%20character%20in%20trench%20coat%2C%20magnifying%20glass%2C%20dark%20alley%20background%20with%20street%20lamps%2C%20film%20noir%20atmosphere%2C%20seinen%20manga%20style%2C%20mysterious%20shadows%2C%20detailed%20urban%20setting%2C%20clean%20composition&width=400&height=560&seq=manga-cover-08&orientation=portrait",
    category: "xuanyi",
    description: "天才高中生侦探叶推理拥有过人的观察力和推理能力。当校园里发生了一系列看似无关的奇怪事件，他敏锐地察觉到背后隐藏着一个惊天阴谋。缜密的逻辑、精彩的推理，让你沉浸其中！",
    status: "连载中",
    rating: 9.5,
    views: 1670000,
    updateDate: "2026-07-30",
    tags: ["悬疑", "推理", "校园", "智斗"],
    chapters: [
      { num: 1, title: "第一话 天才侦探", date: "2025-11-05" },
      { num: 2, title: "第二话 消失的试卷", date: "2025-11-12" },
      { num: 3, title: "第三话 图书馆秘密", date: "2025-11-19" },
      { num: 4, title: "第四话 密码", date: "2025-11-26" },
      { num: 5, title: "第五话 幕后黑手", date: "2025-12-03" },
      { num: 6, title: "第六话 最终推理", date: "2025-12-10" },
      { num: 7, title: "第七话 真相大白", date: "2025-12-17" },
      { num: 8, title: "第八话 新的谜题", date: "2025-12-24" },
    ],
  },
  {
    id: 9,
    title: "恋爱方程式",
    author: "慕容雪",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20anime%20manga%20illustration%20of%20a%20couple%20studying%20together%20in%20library%2C%20shy%20expressions%2C%20books%20and%20notebooks%2C%20warm%20lighting%20from%20window%2C%20soft%20color%20palette%2C%20shojo%20manga%20style%2C%20gentle%20atmosphere%2C%20clean%20composition%2C%20delicate%20art&width=400&height=560&seq=manga-cover-09&orientation=portrait",
    category: "lianai",
    description: "理科天才苏念和文科才女林诗音因为一次意外成了学习搭档。理性与感性的碰撞，公式与诗句的交融，一段独属于学霸之间的甜蜜恋爱方程式正在悄然上演。",
    status: "连载中",
    rating: 9.4,
    views: 1450000,
    updateDate: "2026-08-04",
    tags: ["恋爱", "校园", "学霸", "甜蜜"],
    chapters: [
      { num: 1, title: "第一话 意外的搭档", date: "2025-07-10" },
      { num: 2, title: "第二话 图书馆时光", date: "2025-07-17" },
      { num: 3, title: "第三话 心动的公式", date: "2025-07-24" },
      { num: 4, title: "第四话 雨天", date: "2025-07-31" },
      { num: 5, title: "第五话 真心话", date: "2025-08-07" },
      { num: 6, title: "第六话 告白方程式", date: "2025-08-14" },
    ],
  },
  {
    id: 10,
    title: "龙之契约",
    author: "龙飞",
    cover: "https://readdy.ai/api/search-image?query=Epic%20anime%20manga%20illustration%20of%20a%20hero%20riding%20a%20magnificent%20dragon%2C%20medieval%20fantasy%20setting%2C%20golden%20and%20crimson%20color%20scheme%2C%20dramatic%20sky%20with%20clouds%2C%20shonen%20manga%20style%2C%20powerful%20dynamic%20composition%2C%20detailed%20armor%20design&width=400&height=560&seq=manga-cover-10&orientation=portrait",
    category: "qihuan",
    description: "在人与龙共存的世界，少年雷诺意外与远古龙族签订了契约。获得了龙之力的他，背负起了拯救世界的使命。宏大的世界观，震撼的战斗场面，带你进入龙与魔法的奇幻史诗！",
    status: "连载中",
    rating: 9.6,
    views: 2890000,
    updateDate: "2026-08-02",
    tags: ["奇幻", "龙", "冒险", "战斗"],
    chapters: [
      { num: 1, title: "第一话 龙之遗迹", date: "2024-12-01" },
      { num: 2, title: "第二话 契约之刻", date: "2024-12-08" },
      { num: 3, title: "第三话 龙的试炼", date: "2024-12-15" },
      { num: 4, title: "第四话 黑暗降临", date: "2024-12-22" },
      { num: 5, title: "第五话 盟友", date: "2024-12-29" },
      { num: 6, title: "第六话 天空之战", date: "2025-01-05" },
      { num: 7, title: "第七话 龙之谷", date: "2025-01-12" },
      { num: 8, title: "第八话 最终契约", date: "2025-01-19" },
      { num: 9, title: "第九话 新生", date: "2025-01-26" },
    ],
  },
  {
    id: 11,
    title: "午夜食堂",
    author: "深夜",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20anime%20manga%20illustration%20of%20a%20small%20night%20food%20stall%20with%20warm%20lighting%2C%20steaming%20food%2C%20lonely%20customers%2C%20quiet%20night%20street%2C%20soft%20yellow%20and%20brown%20tones%2C%20slice%20of%20life%20manga%20style%2C%20nostalgic%20atmosphere%2C%20detailed%20food%20artwork&width=400&height=560&seq=manga-cover-11&orientation=portrait",
    category: "gaoxiao",
    description: "城市角落的一家只在午夜营业的小食堂，老板是一位神秘的料理高手。每个深夜前来的客人都有着各自的故事，而美食则成为了治愈心灵的良药。温暖人心的治愈系美食漫画。",
    status: "已完结",
    rating: 9.5,
    views: 1780000,
    updateDate: "2026-05-30",
    tags: ["美食", "治愈", "日常", "温情"],
    chapters: [
      { num: 1, title: "第一话 深夜来客", date: "2025-08-01" },
      { num: 2, title: "第二话 妈妈的拉面", date: "2025-08-08" },
      { num: 3, title: "第三话 失恋咖喱", date: "2025-08-15" },
      { num: 4, title: "第四话 父亲的蛋炒饭", date: "2025-08-22" },
      { num: 5, title: "第五话 最后的深夜", date: "2025-08-29" },
    ],
  },
  {
    id: 12,
    title: "影之继承者",
    author: "黑影",
    cover: "https://readdy.ai/api/search-image?query=Ninja%20anime%20manga%20illustration%20of%20a%20shadowy%20figure%20on%20rooftop%20at%20night%2C%20moon%20in%20background%2C%20dark%20purple%20and%20black%20color%20scheme%2C%20stealthy%20pose%2C%20urban%20night%20setting%2C%20shonen%20manga%20style%2C%20mysterious%20atmosphere%2C%20clean%20composition&width=400&height=560&seq=manga-cover-12&orientation=portrait",
    category: "rexue",
    description: "平凡少年影一从祖父那里继承了神秘的'影之力'。从此，他白天是普通的高中生，夜晚则化身为守护城市的暗影战士。双重身份、激烈战斗、成长蜕变，热血与责任并存的故事。",
    status: "连载中",
    rating: 9.3,
    views: 1340000,
    updateDate: "2026-07-28",
    tags: ["热血", "忍者", "超能力", "校园"],
    chapters: [
      { num: 1, title: "第一话 继承", date: "2025-10-05" },
      { num: 2, title: "第二话 暗影之力", date: "2025-10-12" },
      { num: 3, title: "第三话 首次任务", date: "2025-10-19" },
      { num: 4, title: "第四话 敌人出现", date: "2025-10-26" },
      { num: 5, title: "第五话 同伴", date: "2025-11-02" },
      { num: 6, title: "第六话 影之战", date: "2025-11-09" },
    ],
  },
  {
    id: 13,
    title: "时光图书馆",
    author: "书虫",
    cover: "https://readdy.ai/api/search-image?query=Magical%20anime%20manga%20illustration%20of%20a%20grand%20library%20with%20floating%20books%2C%20warm%20golden%20light%2C%20bookshelves%20reaching%20to%20ceiling%2C%20mystical%20atmosphere%2C%20fantasy%20manga%20style%2C%20dust%20particles%20in%20sunlight%2C%20cozy%20reading%20nook%2C%20detailed%20architecture&width=400&height=560&seq=manga-cover-13&orientation=portrait",
    category: "qihuan",
    description: "在一家古老的图书馆里，每一本书都连接着不同的时空。管理员钟书言意外发现可以通过书籍穿越时空。他踏上了一段段奇妙的书中之旅，见证历史、探索未来，也在旅程中找到了人生的意义。",
    status: "已完结",
    rating: 9.7,
    views: 1560000,
    updateDate: "2026-04-15",
    tags: ["奇幻", "时空", "治愈", "文学"],
    chapters: [
      { num: 1, title: "第一话 古老图书馆", date: "2025-02-14" },
      { num: 2, title: "第二话 书页之间", date: "2025-02-21" },
      { num: 3, title: "第三话 维多利亚时代", date: "2025-02-28" },
      { num: 4, title: "第四话 未来的城市", date: "2025-03-07" },
      { num: 5, title: "第五话 时间守护者", date: "2025-03-14" },
      { num: 6, title: "第六话 书中的秘密", date: "2025-03-21" },
      { num: 7, title: "第七话 最后一页", date: "2025-03-28" },
    ],
  },
  {
    id: 14,
    title: "鬼校迷踪",
    author: "夜不语",
    cover: "https://readdy.ai/api/search-image?query=Creepy%20anime%20manga%20illustration%20of%20an%20abandoned%20school%20building%20at%20night%2C%20broken%20windows%2C%20ghostly%20figure%20in%20corridor%2C%20pale%20blue%20and%20gray%20tones%2C%20horror%20manga%20style%2C%20flickering%20lights%2C%20eerie%20atmosphere%2C%20detailed%20environment&width=400&height=560&seq=manga-cover-14&orientation=portrait",
    category: "kongbu",
    description: "一群大学生为了完成课题研究，来到了一所废弃多年的旧学校。然而，他们很快发现这所学校并非空无一人——徘徊在走廊中的诡异身影，教室里传来的奇怪声音，一个个恐怖事件接连发生。",
    status: "连载中",
    rating: 9.0,
    views: 890000,
    updateDate: "2026-08-01",
    tags: ["恐怖", "校园", "灵异", "生存"],
    chapters: [
      { num: 1, title: "第一话 废弃校舍", date: "2026-03-01" },
      { num: 2, title: "第二话 第一夜", date: "2026-03-08" },
      { num: 3, title: "第三话 钢琴声", date: "2026-03-15" },
      { num: 4, title: "第四话 镜中之人", date: "2026-03-22" },
      { num: 5, title: "第五话 地下室", date: "2026-03-29" },
    ],
  },
  {
    id: 15,
    title: "青春不散场",
    author: "青春派",
    cover: "https://readdy.ai/api/search-image?query=Bright%20anime%20manga%20illustration%20of%20graduation%20day%2C%20group%20of%20friends%20in%20school%20uniforms%20smiling%2C%20cherry%20blossoms%2C%20blue%20sky%2C%20youthful%20energy%2C%20warm%20sunlight%2C%20school%20building%20background%2C%20slice%20of%20life%20manga%20style%2C%20nostalgic%20feeling&width=400&height=560&seq=manga-cover-15&orientation=portrait",
    category: "xiaoyuan",
    description: "五个性格迥异的高中生，从陌生到相识，从争吵到理解，一起度过了三年最难忘的青春时光。毕业在即，他们约定：青春不散场，友谊永存。一部关于友情与成长的青春物语。",
    status: "已完结",
    rating: 9.2,
    views: 1120000,
    updateDate: "2026-03-20",
    tags: ["校园", "友情", "青春", "成长"],
    chapters: [
      { num: 1, title: "第一话 开学日", date: "2025-09-01" },
      { num: 2, title: "第二话 五人组", date: "2025-09-08" },
      { num: 3, title: "第三话 争吵与和解", date: "2025-09-15" },
      { num: 4, title: "第四话 学园祭", date: "2025-09-22" },
      { num: 5, title: "第五话 修学旅行", date: "2025-09-29" },
      { num: 6, title: "第六话 各自的梦想", date: "2025-10-06" },
      { num: 7, title: "第七话 毕业", date: "2025-10-13" },
    ],
  },
  {
    id: 16,
    title: "深海猎人",
    author: "海明",
    cover: "https://readdy.ai/api/search-image?query=Underwater%20anime%20manga%20illustration%20of%20divers%20exploring%20deep%20ocean%2C%20ancient%20ruins%2C%20giant%20sea%20creatures%2C%20blue%20and%20teal%20color%20scheme%2C%20deep%20sea%20atmosphere%2C%20adventure%20manga%20style%2C%20mysterious%20underwater%20light%2C%20detailed%20environment&width=400&height=560&seq=manga-cover-16&orientation=portrait",
    category: "maoxian",
    description: "深海猎人组织专门探索海洋深处的神秘遗迹和未知生物。新晋猎人深海在一次任务中发现了失落的亚特兰蒂斯遗迹，由此展开了一场惊心动魄的深海冒险。",
    status: "连载中",
    rating: 9.3,
    views: 1230000,
    updateDate: "2026-07-25",
    tags: ["冒险", "海洋", "遗迹", "科幻"],
    chapters: [
      { num: 1, title: "第一话 深海猎人", date: "2026-02-01" },
      { num: 2, title: "第二话 深渊之眼", date: "2026-02-08" },
      { num: 3, title: "第三话 海底城市", date: "2026-02-15" },
      { num: 4, title: "第四话 守护巨兽", date: "2026-02-22" },
      { num: 5, title: "第五话 遗迹之谜", date: "2026-03-01" },
      { num: 6, title: "第六话 深海之光", date: "2026-03-08" },
    ],
  },
  {
    id: 17,
    title: "迷雾山庄",
    author: "侦探李",
    cover: "https://readdy.ai/api/search-image?query=Mysterious%20anime%20manga%20illustration%20of%20a%20foggy%20mansion%20on%20a%20hill%2C%20Victorian%20architecture%2C%20dark%20forest%20surrounding%2C%20dim%20light%20from%20windows%2C%20mystery%20manga%20style%2C%20suspenseful%20atmosphere%2C%20silhouetted%20figure%20in%20doorway%2C%20detailed%20gothic%20elements&width=400&height=560&seq=manga-cover-17&orientation=portrait",
    category: "xuanyi",
    description: "著名侦探霍华德受邀来到一座与世隔绝的山庄参加晚宴，当晚主人却离奇死亡。暴风雪封锁了所有出路，山庄变成了密室。每个人都有嫌疑，每个人都在说谎。经典的暴风雪山庄模式推理漫画。",
    status: "已完结",
    rating: 9.6,
    views: 1980000,
    updateDate: "2026-05-10",
    tags: ["悬疑", "推理", "密室", "经典"],
    chapters: [
      { num: 1, title: "第一话 邀请函", date: "2025-12-01" },
      { num: 2, title: "第二话 暴风雪之夜", date: "2025-12-08" },
      { num: 3, title: "第三话 命案", date: "2025-12-15" },
      { num: 4, title: "第四话 逐个审讯", date: "2025-12-22" },
      { num: 5, title: "第五话 关键线索", date: "2025-12-29" },
      { num: 6, title: "第六话 真相", date: "2026-01-05" },
    ],
  },
  {
    id: 18,
    title: "甜蜜契约",
    author: "糖果",
    cover: "https://readdy.ai/api/search-image?query=Sweet%20romantic%20anime%20manga%20illustration%20of%20a%20couple%20sharing%20dessert%20at%20a%20cafe%2C%20pink%20and%20cream%20color%20palette%2C%20cozy%20cafe%20setting%2C%20blushing%20expressions%2C%20shojo%20manga%20style%2C%20soft%20lighting%2C%20detailed%20food%20artwork%2C%20gentle%20romantic%20atmosphere&width=400&height=560&seq=manga-cover-18&orientation=portrait",
    category: "lianai",
    description: "为了帮家族甜品店渡过难关，唐果果与神秘美食评论家签订了'甜蜜契约'——她要在一个月内做出能打动对方的完美甜品。在日复一日的相处中，甜品的甜蜜也慢慢渗透到了两人的心里。",
    status: "连载中",
    rating: 9.1,
    views: 780000,
    updateDate: "2026-08-04",
    tags: ["恋爱", "美食", "甜宠", "都市"],
    chapters: [
      { num: 1, title: "第一话 契约", date: "2026-06-01" },
      { num: 2, title: "第二话 第一道甜品", date: "2026-06-08" },
      { num: 3, title: "第三话 美食评论家", date: "2026-06-15" },
      { num: 4, title: "第四话 心动的味道", date: "2026-06-22" },
      { num: 5, title: "第五话 甜蜜升级", date: "2026-06-29" },
    ],
  },
  {
    id: 19,
    title: "机甲学院",
    author: "钢铁意志",
    cover: "https://readdy.ai/api/search-image?query=Mecha%20anime%20manga%20illustration%20of%20a%20giant%20robot%20in%20hangar%2C%20students%20in%20pilot%20suits%2C%20futuristic%20technology%2C%20silver%20and%20blue%20color%20scheme%2C%20sci-fi%20school%20setting%2C%20action%20manga%20style%2C%20dynamic%20composition%2C%20detailed%20mechanical%20design&width=400&height=560&seq=manga-cover-19&orientation=portrait",
    category: "rexue",
    description: "在未来的机甲学院，少年凯因梦想成为最强的机甲驾驶员。然而，他驾驶的却是一台老旧的训练机甲。凭借不屈的意志和过人的天赋，他一步步证明：驾驶员比机甲更重要！科幻热血机甲漫画。",
    status: "连载中",
    rating: 9.4,
    views: 2100000,
    updateDate: "2026-08-03",
    tags: ["热血", "机甲", "科幻", "学院"],
    chapters: [
      { num: 1, title: "第一话 入学考试", date: "2025-11-10" },
      { num: 2, title: "第二话 老旧机甲", date: "2025-11-17" },
      { num: 3, title: "第三话 初次对战", date: "2025-11-24" },
      { num: 4, title: "第四话 觉醒", date: "2025-12-01" },
      { num: 5, title: "第五话 学院联赛", date: "2025-12-08" },
      { num: 6, title: "第六话 强敌", date: "2025-12-15" },
      { num: 7, title: "第七话 突破", date: "2025-12-22" },
      { num: 8, title: "第八话 冠军之路", date: "2025-12-29" },
    ],
  },
  {
    id: 20,
    title: "妖怪杂货铺",
    author: "九尾",
    cover: "https://readdy.ai/api/search-image?query=Charming%20anime%20manga%20illustration%20of%20a%20cozy%20old%20shop%20filled%20with%20magical%20items%2C%20yokai%20spirits%2C%20traditional%20Japanese%20aesthetic%2C%20warm%20lighting%2C%20whimsical%20atmosphere%2C%20fantasy%20slice%20of%20life%20manga%20style%2C%20detailed%20interior%2C%20mysterious%20shopkeeper&width=400&height=560&seq=manga-cover-20&orientation=portrait",
    category: "qihuan",
    description: "在城市的老街深处，有一家不起眼的杂货铺。这里出售的不是普通商品，而是能够实现愿望的神奇物品——但每个愿望都有代价。店主是一只活了千年的九尾狐，她用智慧帮助每一个有缘的客人。",
    status: "连载中",
    rating: 9.5,
    views: 1450000,
    updateDate: "2026-07-31",
    tags: ["奇幻", "妖怪", "治愈", "单元剧"],
    chapters: [
      { num: 1, title: "第一话 第一个客人", date: "2025-06-15" },
      { num: 2, title: "第二话 遗忘之伞", date: "2025-06-22" },
      { num: 3, title: "第三话 回忆相框", date: "2025-06-29" },
      { num: 4, title: "第四话 勇气之铃", date: "2025-07-06" },
      { num: 5, title: "第五话 缘分红线", date: "2025-07-13" },
      { num: 6, title: "第六话 九尾的秘密", date: "2025-07-20" },
    ],
  },
];